@if (user) {
<div class="page-header">
  <h1>{{ user.fullname }}</h1>
</div>

<div class="page-body">
  <div class="card role-panel">
    <label class="form-label">Rôles attribués</label>
    @if (user.permissions.length > 0) {
    <div class="role-chips">
      @for (role of user.permissions; track role) {
      @if (!role.startsWith('OP_')) {
      <span class="badge rounded-pill role-chip">
        {{ role }}
        <button type="button" (click)="unassign(role)" aria-label="Retirer ce rôle">
          <em class="fal fa-times"></em>
        </button>
      </span>
      }
      }
    </div>
    }

    @if (user.isRoot()) {
    <label class="form-label field-label-spaced">Permissions (root)</label>
    <div class="role-chips">
      @for (role of user.permissions; track role) {
      @if (role.startsWith('OP_')) {
      <span class="badge rounded-pill badge rounded-pill role-chip role-chip-readonly">{{ role }}</span>
      }
      }
    </div>
    }

    <label class="form-label field-label-spaced">Ajouter un rôle</label>
    <div class="add-role-row">
      @if (allRoles) {
      <select [(ngModel)]="newRole" class="form-select">
        <option></option>
        @for (role of availableRoles(); track role) {
        @if (!user.hasRole(role)) {
        <option [value]="role.id">{{ role.name }}</option>
        }
        }
      </select>
      }
      <button (click)="addRole()" [disabled]="!newRole" class="btn btn-light" type="button">
        <em class="far fa-check"></em> Ajouter
      </button>
    </div>
  </div>
</div>
}
